import React from 'react';
import AdminNavigation from '../AdminNavigation/AdminNavigation'; // ✅ CORRIGÉ - Supprimé .tsx
import * as styles from './adminLayout.css'; // ✅ CORRIGÉ - Supprimé .ts

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className={styles.adminLayout}>
      <AdminNavigation />
      <main className={styles.mainContent}> {/* ✅ CORRIGÉ - name correct du style */}
        {children}
      </main>
    </div>
  );
};

// ✅ addition - Export nommé
export { AdminLayout };

// ✅ Export par defect (existant)
export default AdminLayout;